import styled from '@emotion/styled'
import { WorkspaceTab } from '@sales-app/context/workspace/workspace.type'
import { Status } from '@sales-app/graphql/queries/potentialBooking/status.queries'
import { CommunicationLogs } from '@sales-app/views/Workspace/PersonSummary/CommunicationLogs/CommunicationLogs'
import React, { FC } from 'react'

import { Tab, Tabs } from '@/components/Tabs'

import { FollowupSection } from '../FollowupSection/FollowupSection'
import { SectionContainer } from '../PotentialBooking'
import { PinnedAndFavorites } from './PinnedAndFavorites/PinnedAndFavorites'
import { RecommendedHomes } from './RecommendedHomes/RecommendedHomes'

type Props = {
  bookablePerson: WorkspaceTab
  potentialBookingStatuses: Status[]
  refetchPotentialBooking: () => void
}

export const ActivitySection: FC<Props> = ({ bookablePerson, potentialBookingStatuses, refetchPotentialBooking }) => {
  return (
    <SectionContainer className="flex flex-col flex-1 flex-grow">
      <StyledTabs className="flex flex-auto overflow-auto">
        <Tabs>
          <Tab key="followUpTasks" title="Checklist">
            <FollowupSection
              bookablePerson={bookablePerson}
              potentialBookingStatuses={potentialBookingStatuses}
              refetchPotentialBooking={refetchPotentialBooking}
            />
          </Tab>
          <Tab key="recommendedHomes" title="Recommended Homes">
            <RecommendedHomes bookablePerson={bookablePerson} />
          </Tab>
          <Tab key="favorites" title="Favorites & Pinned">
            <PinnedAndFavorites bookablePerson={bookablePerson} />
          </Tab>
          <Tab key="communications" title="Communications">
            <CommunicationLogs bookablePerson={bookablePerson} />
          </Tab>
        </Tabs>
      </StyledTabs>
    </SectionContainer>
  )
}

const StyledTabs = styled.div`
  .tabs-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .title-container {
    border-color: #e7e6e4;
    position: relative;
    margin-bottom: 0.5rem;
    border-width: 1px;
    min-height: 3rem;
    height: 3rem;
    max-height: 3rem;
    border-radius: 0.5rem;
  }

  .active-tab {
    display: flex;
    width: 100%;
  }

  .tab-title {
    position: relative;
    flex: 1;
    margin-right: 0;
    overflow: hidden;

    button {
      background-color: transparent;
      border-radius: 0.5rem;
      padding-left: 0.25rem;
      padding-right: 0.25rem;
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
      width: 100%;
      height: 100%;
      text-align: center;
      white-space: nowrap;
      font-weight: 500;
      font-size: 0.875rem;
      line-height: 140%;
      text-transform: capitalize;

      @media (min-width: 768px) {
        font-size: 1rem;
      }

      cursor: pointer;
    }

    &.active {
      button {
        color: white;
        font-weight: 700;
        background-color: black;
      }
    }
  }
`
